import { axios } from '@Root/API'

export const post = payload => {
  return axios.post(`student-engagement/rollover-leavers`, payload)
}
